import { Analytics } from "@/components/Analytics";
import { CommunityFeedInsightsWidget } from "@/components/Analytics/CommunityFeedInsightsWidget/CommunityFeedInsightsWidget";
import { PageGrid } from "@/components/PageGrid/PageGrid";
import { Paper } from "@/components/Paper/Paper";
import { canAccessAnalytics } from "@/components/ProjectSidebar/permissions";
import { useSessionUser } from "@/hooks/Network/useSessionUser";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { usePermission } from "@/hooks/usePermission";
import { useConfig } from "@/providers/config/useConfig";

import { HomeCommunityPostList } from "../components/HomeCommunityPostList";
import { HomeDataWidgets } from "../components/HomeDataWidgets";
import { HomeFahFollowUpSuggestionWidget } from "../components/HomeFahSuggestionWidget";
import { HomeFahWidget_LEGACY } from "../components/HomeFahWidget_LEGACY";

export function Layout(): React.ReactNode {
  const sessionUser = useSessionUser();
  const isAnalyticsV2Available = useConfig("isAnalyticsV2Available");
  const hasPermission = usePermission();

  useDocumentTitle(undefined);

  const canViewDataWidgets = sessionUser.isAdmin && sessionUser.role.type !== "maintenance";
  const canViewFahWidget = sessionUser.isAdmin;

  return (
    <Paper theme="no-header-minimal">
      {isAnalyticsV2Available && (
        <PageGrid.Grid>
          {canViewFahWidget && (
            <>
              {/* Row 1 */}
              <PageGrid.Item size="100%" isDesktopIndifferent>
                <Analytics.FahWidget />
              </PageGrid.Item>

              {/* Row 2 */}
              <PageGrid.Item size="66%" isDesktopIndifferent>
                <HomeFahFollowUpSuggestionWidget />
              </PageGrid.Item>
              <PageGrid.Item size="33%" isDesktopIndifferent>
                <CommunityFeedInsightsWidget />
              </PageGrid.Item>
            </>
          )}

          {/* Row 3 */}
          {hasPermission(canAccessAnalytics) && (
            <PageGrid.Item size="100%" isDesktopIndifferent>
              <PageGrid.Grid>
                <PageGrid.Item size="33%" isDesktopIndifferent>
                  <Analytics.AdoptionWidget />
                </PageGrid.Item>
                <PageGrid.Item size="33%" isDesktopIndifferent>
                  <Analytics.EngagementWidget />
                </PageGrid.Item>
                <PageGrid.Item size="33%" isDesktopIndifferent>
                  <Analytics.SocialContributionWidget />
                </PageGrid.Item>
              </PageGrid.Grid>
            </PageGrid.Item>
          )}

          {/* Row 4 */}
          <PageGrid.Item size="66%" isDesktopIndifferent>
            <HomeCommunityPostList />
          </PageGrid.Item>
        </PageGrid.Grid>
      )}
      {!isAnalyticsV2Available && (
        <div className="max-w-[880px] 2xl:max-w-none">
          <div className="grid grid-cols-1 grid-rows-[auto_auto] gap-4 2xl:grid-cols-[min-content_auto] 2xl:justify-between 2xl:gap-x-16">
            {canViewFahWidget && <HomeFahWidget_LEGACY />}
            {canViewDataWidgets ? <HomeDataWidgets /> : <div />}
            <HomeCommunityPostList />
          </div>
        </div>
      )}
    </Paper>
  );
}
